export default {
  namespaced: true,
  getters: {
    me() {
      return JSON.parse(localStorage.getItem('userData')) || null
    },
  },
}
